
const classPrefix = 'service-card'
const dataPrefix = 'data-service-card'

const $container = document.querySelector(`[${dataPrefix}]`)

if ($container) {
    serviceСard();
}

export function serviceСard() {

}
